import request from '@/utils/request';

// 获取portals => party下的dirs
export async function qryDirsByParty(portalId, partyId) {
  return request(`/portals/${portalId}/party/${partyId}/dirs`);
}

// 获取dirs下的dirs
export async function qryDirsByDir(dirId) {
  return request(`/dirs/${dirId}/dirs`);
}

export async function qryDirs(portalId, partyId) {
  return request(`/portals/${portalId}/party/${partyId}`);
}
